import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M6.707 4.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L5.414 8H16a4 4 0 0 1 4 4c0 2.391-1.279 3.706-2.316 4.051a1 1 0 0 0 .632 1.898C20.28 17.294 22 15.132 22 12a6 6 0 0 0-6-6H5.414z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.342 21.12c-2.064 0-3.276-1.74-3.276-4.32 0-2.592 1.212-4.32 3.276-4.32 2.076 0 3.288 1.728 3.288 4.32 0 2.58-1.212 4.32-3.288 4.32m0-1.728c.912 0 1.464-.816 1.464-2.592s-.552-2.592-1.464-2.592c-.9 0-1.452.816-1.452 2.592s.552 2.592 1.452 2.592",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.05 12.6V21H5.286v-5.964l-1.872 1.44v-2.124L5.862 12.6z" })
);
var SvgBackward10Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Backward10Outlined_default = SvgBackward10Outlined;

export { Backward10Outlined_default as default };
